import { useEffect } from 'react';
import useDevConsoleProtection from '../../hook/useDevConsoleProtection';

interface DevConsoleProtectionProps {
  children: React.ReactNode;
}

/**
 * Komponen wrapper untuk proteksi developer console
 */
const DevConsoleProtection: React.FC<DevConsoleProtectionProps> = ({ children }) => {
  const { isProtectionEnabled, isTextSelectionEnabled } = useDevConsoleProtection();

  useEffect(() => {
    if (isProtectionEnabled && !isTextSelectionEnabled) {
      // Disable text selection dan drag ketika kedua kondisi terpenuhi
      const bodyStyle = document.body.style as any;
      bodyStyle.webkitTouchCallout = 'none';
      bodyStyle.webkitUserSelect = 'none';
      bodyStyle.khtmlUserSelect = 'none';
      bodyStyle.mozUserSelect = 'none';
      bodyStyle.msUserSelect = 'none';
      document.body.style.userSelect = 'none';

      document.body.ondragstart = () => false;
      document.body.onselectstart = () => false;

      // Cleanup
      return () => {
        bodyStyle.webkitTouchCallout = '';
        bodyStyle.webkitUserSelect = '';
        bodyStyle.khtmlUserSelect = '';
        bodyStyle.mozUserSelect = '';
        bodyStyle.msUserSelect = '';
        document.body.style.userSelect = '';

        document.body.ondragstart = null;
        document.body.onselectstart = null;
      };
    }
  }, [isProtectionEnabled, isTextSelectionEnabled]);

  return <>{children}</>;
};

export default DevConsoleProtection;